/* global $ */
import Verify_Email from "./email_verification.js";

// SEs available address fields
const ADDRESS_PARAMS = [
    "address_1",
    "address_2",
    "address_3",
    "address_4",
    "city",
    "state",
    "postal_code",
    "country",
    "address_validated",
    "validation_delivery_point",
];

export default function (form, config) {
    // Runs Address Verification for All submitted Addresses
    $(".js-qas-submit").prop("disabled", true);

    // Set Address fields if we're using a template (address, billing, shipping)
    if (config.ADDRESSES) {
        config.ADDRESS_FIELDS = get_address_fields(config.ADDRESSES);
    }

    run_verification(form, config).then(result => {
        if (result) {
            // Submit the form.
            reset_address_verification_block();

            // Verify Email address if configured
            if (config.EMAIL) {
                Verify_Email(form, config.EMAIL);
            }
            else {
                $(form).submit();
            }
        } else {
            // Exit Submission and return to the form
            $(".js-qas-submit").prop("disabled", false);
            return false;
        }
    });
}

// Format each Address, and submit to API function
async function run_verification(form, config) {
    $("body").addClass("verifying_address");

    // Are we usig an alternate endpoint? (e.g. for US/USA)
    var alt = false;
    if (config.alt) {
        alt = config.alt;
    }

    // Iterate through submitted addresses submitted
    for (var i = 0; i < config.ADDRESS_FIELDS.length; i++) {
        let address_data = {};
        let address_fields = config.ADDRESS_FIELDS[i];

        // Skip if we've not edited this
        if (isHidden($(address_fields["country"]))) {
            continue;
        }

        // Set Address Values
        for (var key in address_fields) {
            address_data[key] = $(address_fields[key]).val();
        }

        // Request API results
        let data = await request_address_verification(address_data, alt);
        if (data) {

            // User has options to choose from
            if (data["prompt"]) {

                // Show the Options
                $("#address_processing").hide();
                $("#address_prompt").data(address_fields).show();

                // Show the Address as Entered
                let current = get_address_value(address_data); 
                $("#address_prompt .prompt_box__entered address").html(current);

                // Show Address Suggestions
                if (data["addresses"].length) {
                    for (var j = 0; j < data["addresses"].length; j++) {
                        let address_opt = {};
                        ADDRESS_PARAMS.forEach(key => {
                            if (data["addresses"][j][key]) {
                                address_opt[key] = data["addresses"][j][key];
                            }
                        });
                        var $address_box = $("#address_option__wrapper .address_option").clone();
                        $address_box.find(".js-address_option").data(address_opt);
                        $address_box.find("address").html(get_address_value(address_opt));
                        $("#address_prompt .prompt_box__suggestion .js-address_options").append($address_box);
                    }
                } 
                // No Suggestions Available
                else {
                    $("#address_prompt .prompt_box__suggestion .js-address_nooptions").show();
                }

                // Wait for the User to make a selection.
                let result = await new Promise(function (resolve) {
                    $(document).off("click", ".js-address_option").on("click", ".js-address_option", function (ev) {
                        $(".js-address_option").unbind();
                        // Return to Form
                        if ($(ev.currentTarget).hasClass("js-edit_address")) {
                            // Find the ScrollTo location.
                            let anchor = address_fields["address_1"].replace("#", "");
                            record_address_stats(current, "edit");
                            document.getElementById(anchor).scrollIntoView({ behavior: "smooth", block: "center" });
                            reset_address_verification_block();
                            resolve(false);
                        }
                        // Use the Address as Entered (NOT verified)
                        else if ($(ev.currentTarget).hasClass("js-use_address")) {
                            record_address_stats(current, "use");
                            reset_address_prompt_block();
                            $(address_fields["address_validated"]).val("False");
                            resolve(true);
                        }
                        // Use one of the Suggested Addresses (YES verified)
                        else {
                            // Set the form to match this address
                            record_address_stats(current, "select");
                            let new_address = $(ev.currentTarget).data();
                            ADDRESS_PARAMS.forEach(key => {
                                let my_val = new_address[key] || " ";
                                if (key == "address_validated") {
                                    my_val = "True";
                                }

                                // Address Configs need to contain all of the values
                                $(address_fields[key]).val(my_val);
                                if (key == "country" || key == "state") {
                                    $(address_fields[key]).trigger("change");
                                }
                            });
                            reset_address_prompt_block();
                            resolve(true);
                        }
                    });
                });

                // User is going to Edit the address.  Exit the Process
                if (result === false) {
                    return false;
                }
            }
            // Address if Verified. Set Values in form.
            else if (data["success"]) {
                let my_address = data["addresses"].shift();
                for (var item in address_fields) {
                    if (item === "address_validated") {
                        $(address_fields[item]).val("True");
                    } else {
                        $(address_fields[item]).val(my_address[item]);
                    }
                }
            }
            else {
                // No error, but not verified
                $(address_fields["address_validated"]).val("False");
            }
        }
        // There was an error and no data was returned          
        else {
            $(address_fields["address_validated"]).val("False");
        }
    }

    // Completed Verifying All Addresses. 
    return true;
}

// Hit API for all of the Addresses we are checking
async function request_address_verification(address_data, alt=false) {
    // Submit address to API 
    return new Promise((resolve) => {
        var url = "/addresses/api/verify/";

        // SE uses USA for US
        if (alt == "SE") {
            url = "/addresses/api/verify/se/";
        } 
        // Satchmo uses ints for country keys
        else if (alt == "STORE") {
            url = "/addresses/api/verify/store/";
        }

        $.ajax({
            type: "POST",
            url: url,
            data: address_data,
            dataType: "json",
        }).done(function (data) {
            // Return Data
            resolve(data);
        }).fail(function () {
            // There was a problem. Return Not Verified.
            resolve(false);
        });
    });
}

// Utils

// Is this element visible?
function isHidden(e) {
    return !(e.is(":visible"));
}

// Hide all the Address Verification UI
function reset_address_verification_block() {
    $("body").removeClass("verifying_address");
    reset_address_prompt_block();
}

// Reset the Address Prompt Modal
function reset_address_prompt_block() {
    $("#address_prompt").removeData().hide();
    $("#address_processing").show();
    $("#address_prompt .prompt_box__suggestion .js-address_options").html(" ");
    $("#address_prompt .prompt_box__suggestion .js-address_nooptions").hide();
}

// Only display the Address data we care about.
function get_address_value(address_data) {
    let my_display = [];
    for (const[key, value] of Object.entries(address_data)) {
        // Countries are occasionally numeric
        if (key == "country" && (!(/[^0-9]/.test(value)))) {
            continue;
        } else if (!!value && typeof value === "string" && value !== "True" && key != "address_validated" && key != "validation_delivery_point" && !!value.trim()) {
            my_display.push(value);    
        }     
    }
    return my_display.join("<br />");
}

// Log Address information to improve Address Matching
function record_address_stats(address, action) {
    // Submit address to API 
    var url = "/addresses/api/verify/prompt/";

    $.ajax({
        type: "POST",
        url: url,
        data: {"address": address, "action": action},
        dataType: "json",
    });
}

// Return full configuration for Standard Address form items.
function get_address_fields(addresses) {
	var prefixes = { 
        billing: 'billing-', 
        shipping: 'shipping-', 
        mailing: 'mailing-',
    };
	return addresses
		.filter(address => Object.keys(prefixes).includes(address))
		.map(address => Object.fromEntries(ADDRESS_PARAMS.map(key => [key, `#${prefixes[address]}${key}`])));
}
